module.exports = __webpack_public_path__ + "img/dea.a623e88c.png";